<template>
    <div class="p20">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新增供应商</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->

        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm"
                v-model="submitForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
    </div>
</template>
<script>
    import AddFormConfig from './add-form'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyRouterButton from '@c/router-button'
    export default {
        mixins: [
            AddFormConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyRouterButton
        },
        data () {
            return {
                submitLoad: false, // 提交按钮的状态标识
                submitForm: {}
            }
        },
        mounted () {
            // 设置UUID
            this.submitForm.uuid = this.$utils.createUUID()
        },
        methods: {
            submit () {
                if (this.$refs['searchForm'].validateForm()) {
                    this.submitLoad = true
                    // 获得得查询的字段
                    this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                    // 提交数据
                    this.$api.create('api/providerlist',this.submitForm).then((rs) => {
                        this.$alert('数据提交成功', '新增', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.submitLoad = false
                                // 跳转到详情页面
                                this.$router.push('/bill/provider/list')
                            }
                        });
                        // 更新UUID
                        this.submitForm.uuid = this.$utils.createUUID()
                    }).catch((error) => {
                        this.submitLoad = false
                        this.$message({
                            message: error,
                            type: 'warning'
                        })
                    })
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>